import { yupResolver } from '@hookform/resolvers/yup'
import { Box } from '@mui/material'
import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { acPostPasswordReset } from '../../store/actions'
import { ROUTES } from '../../store/constants'
import { PrimaryButton, Alert } from '../default'

import { FormInputPassword } from './formInputs'
import { FormValidationPasswordReset } from './formValidations'

const defaultValues = {
    newPassword: '',
    confirmPassword: ''
}

/**
 * Renders a form for resetting the password.
 *
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered component.
 */
export const PasswordResetForm = () => {

    const [token, setToken] = useState()

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const isLoadingPasswordReset = useSelector(state => state.auth.isLoadingPasswordReset)
    const hasErrorPasswordReset = useSelector(state => state.auth.hasErrorPasswordReset)

    useEffect(() => {
        const url = new URL(window.location.href)
        const auxToken = url.searchParams.get('token')
        setToken(auxToken)
    }, [])

    const { control, handleSubmit, reset, formState: { errors } } = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(FormValidationPasswordReset)
    })

    const onSubmit = handleSubmit((data) => {
        dispatch(acPostPasswordReset({ newPassword: data.newPassword, token: token }))
            .then(() => navigate(ROUTES.LOGIN, {
                state: {
                    successAlert: 'Senha redefinida com sucesso!'
                }
            }))
            .catch(error => {
                reset()
                console.error(error)
            })
    })

    const getErrorMessage = () => {
        if (!hasErrorPasswordReset) return ''

        switch (hasErrorPasswordReset.description) {
            case 'TOKEN_INVALID':
                return 'Token inválido!'
            case 'TOKEN_EXPIRED':
                return 'Token expirado! Solicite nova recuperação de senha.'
            case 'INFRASTRUCTURE_CONNECTION_ERROR':
                return 'Serviço temporariamente indisponível. Tente novamente mais tarde!'
            default:
                return 'Erro ao redefinir senha!'
        }
    }

    return (
        <Box component='form' onSubmit={onSubmit} noValidate>
            {
                hasErrorPasswordReset && (
                    <Alert severity='error' message={getErrorMessage()} sx={{ mb: 1 }} />
                )
            }
            <FormInputPassword
                name='newPassword'
                label='Nova senha'
                placeholder='Digite sua nova senha'
                control={control}
                errors={errors.newPassword}
                fullWidth
                margin='normal'
                required
            />
            <FormInputPassword
                name='confirmPassword'
                label='Confirmar nova senha'
                placeholder='Confirme sua nova senha'
                control={control}
                errors={errors.confirmPassword}
                fullWidth
                margin='normal'
                required
            />
            <PrimaryButton
                label='Salvar Senha'
                loading={isLoadingPasswordReset}
                type='submit'
                fullWidth
                sx={{ mt: 2 }}
            />
        </Box>
    )

}